import { m } from "@/lib/i18n";

export default function Footer() {
  return (
    <footer className="bg-primary/5 py-4">
      <div className="container flex flex-col items-center justify-between gap-1 text-sm text-muted-foreground sm:flex-row">
        <p suppressHydrationWarning>pdfisfun &middot; {new Date().getFullYear()}</p>
        <p>{m.privacy_task_footer()}</p>
      </div>
    </footer>
  );
}
